import React from 'react';

export default function RecipesByLocationDrink() {
  return (
    <main>
      <p>Not Found</p>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/pages/RecipesByLocationDrink.js